import { MyOrganizationsPage } from './MyOrganizationsPage';
export default MyOrganizationsPage;
